import { getCookie } from 'AccountsUtils'
import { isInFlyinDomain } from 'AccountsUtils'

/**
 * Gets the wallet URL based on the current domain and selected language
 * @returns {string} The wallet URL
 */
export const getWalletUrl = () => {
  // For non-Flyin domains, return the standard wallet path
  if (!isInFlyinDomain()) {
    return '/accounts/wallet'
  }

  // For Flyin domains, construct dynamic URL
  const hostname = window.location.hostname
  const protocol = window.location.protocol
  const selectedLanguage = getCookie('selectedLanguage')
  
  // Determine language code (default to 'en' if not Arabic)
  const langCode = selectedLanguage === 'ar' ? 'ar' : 'en'

  return `${protocol}//${hostname}/${langCode}/wallet`
}
